module.exports = __webpack_public_path__ + "static/media/influencersLegendIcon.c3a7cf1d.svg";